import { render, staticRenderFns } from "./Conclusion_panel.vue?vue&type=template&id=8782578a&scoped=true&"
import script from "./Conclusion_panel.vue?vue&type=script&lang=js&"
export * from "./Conclusion_panel.vue?vue&type=script&lang=js&"
import style0 from "./Conclusion_panel.vue?vue&type=style&index=0&id=8782578a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8782578a",
  null
  
)

component.options.__file = "Conclusion_panel.vue"
export default component.exports